const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const SyncTableStateCommand: any = {
    UpdateSyncTableState: `${Backofficebff}/v1/studio-sync-table-state/update`,
};
